import "@babel/polyfill";

function scrollTo(e, respond = null) {
  e.preventDefault();
  var targetID = respond
    ? respond.getAttribute("href")
    : this.getAttribute("href");
  const targetAnchor = document.querySelector(targetID);
  const ie = document.querySelector(".is-ie");
  if (!targetAnchor) {
    const hero = document.querySelector(".-hero");
    if (ie) {
      window.scrollTo(0, hero.offsetHeight);
    } else {
      window.scrollTo({ top: hero.offsetHeight, left: 0, behavior: "smooth" });
    }
    return;
  }
  if (ie) {
    window.scrollTo(0, targetAnchor.getBoundingClientRect().top + 200);
  } else {
    window.scrollBy({
      top: targetAnchor.getBoundingClientRect().top,
      left: 0,
      behavior: "smooth"
    });
  }
}

// function scrollTo (e, respond = null) {
//   const hero = document.querySelector(".-hero")
//   window.scrollBy({ top: hero.offsetHeight, left: 0, behavior: 'smooth' })
// }

export default (e, respond = null) => {
  const links = document.querySelectorAll("[data-scroll]");
  links.forEach(link => (link.onclick = scrollTo));
};
